<div class="onboarding-container" [ngSwitch]="hasSelectedTrack$ | async">
    <app-onboarding-select-track *ngSwitchCase="false"></app-onboarding-select-track>
    <app-onboarding-applications *ngSwitchCase="true"></app-onboarding-applications>
</div>
